import React, { FC, useMemo, useCallback } from 'react';

// components
import Select, { Props as SelectProps } from 'components/Fields/Select';

const ChannelDropdown: FC<SelectProps> = (props) => {
  const {
    field: { name },
    form: { setValues, initialValues },
  } = props;

  const setFieldValue = useCallback((field: string, value: any, shouldValidate?: boolean) => {
    setValues(
      {
        [field]: value,
        stream_url: value === initialValues[name] ? initialValues.stream_url : '',
      },
      shouldValidate
    );
  }, []);

  const propsWithOverrides = useMemo(
    () => ({
      ...props,
      form: {
        ...props.form,
        setFieldValue,
      },
    }),
    [props]
  );

  return <Select {...propsWithOverrides} />;
};

export default ChannelDropdown;
